import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { endpoints } from "@/lib/api";
import { usePersona } from "@/lib/personaStore";

/**
 * Silent visit tracker: pings /api/track/visit once per browser session (per top-level route).
 * Non-blocking; failures are swallowed so tracking never breaks the app.
 */
export default function VisitTracker() {
  const location = useLocation();
  const { persona } = usePersona();

  useEffect(() => {
    // Skip tracking the tokenised approval public page + the analytics dashboard itself
    if (location.pathname.startsWith("/approve/") || location.pathname.startsWith("/admin/")) return;

    const sessionKey = "flexspace_visit_tracked";
    if (typeof window === "undefined") return;
    if (sessionStorage.getItem(sessionKey)) return;

    endpoints
      .trackVisit({
        path: location.pathname || "/",
        persona: persona?.id || null,
        referrer: document.referrer || "",
      })
      .then(() => {
        sessionStorage.setItem(sessionKey, "1");
      })
      .catch(() => {
        // silent — never let analytics break the UX
      });
  }, [location.pathname, persona]);

  return null;
}
